import type { FC, ReactNode } from "react";

import { Container } from "@aviary/layouts";
import { BannersShim } from "@shared/components/Banners";

import { style, flex } from "./PageContent.styles";

interface Props {
  withSidebar?: boolean;
  children?: ReactNode;
}

/** @deprecated Please use `<PageWrapper>` from `@aviary/layouts` instead */
const PageContent: FC<Props> = ({ withSidebar, children, ...rest }) => {
  return (
    <main css={flex} id="main-content" role="main" tabIndex={0}>
      <BannersShim />
      <Container css={style} {...rest} withSidebar={withSidebar}>
        {children}
      </Container>
    </main>
  );
};

export { PageContent };
